export default function hideMiniContextMenuOnEdge(): void {
  // Hide the mini-menu on Edge browser
  const isEdge = window.navigator.userAgent.includes('Edg');
  if (isEdge) {
    const selection = window.getSelection();
    if (selection) {
      // Check if text is selected
      if (!selection.isCollapsed) {
        // fetch the selection range
        const r = selection.getRangeAt(0);
        // Deselect the text to hide the mini-menu
        selection.removeAllRanges();
        setTimeout(() => {
          // Selection revert
          selection.addRange(r)
        }, 0);
      }
    }
  }
}